
import { mergeMap, catchError, filter, map } from 'rxjs/operators'
import { combineEpics } from 'redux-observable'
import { Epic } from 'interfaces/middleware'
import { USER_IMAGE_UPLOAD, userImageLocalUpdateActionCreator, userImageUploadActionCreator } from 'actions/userImageActions'
import { Observable, merge, of, from, empty } from 'rxjs'
import { AjaxError } from 'rxjs/ajax'
import { getImageSize, ImageSize } from 'helpers/DOMHelpers'
import { postMultipart } from 'helpers/observableAjaxHelpers'
import { POST_MEDIA_IMAGE_URL } from 'interfaces/ajax'
import { Store } from 'interfaces/state'
import { getItemFromCollection } from 'helpers/normalizeHelpers'
import { isExpectedError, processError } from 'helpers/ajaxHelpers'
import { Action } from 'actions'
import { filterRequestOfType } from 'rxOperators/filterRequestOfType'
import { UserImage } from 'interfaces/userImage'

const handleErrors = (errorHandler: (error: AjaxError) => Observable<Action>) => <T>(observable: Observable<T>) => observable.pipe(
  catchError((error) => {
    let errorStream = errorHandler(error)

    if (isExpectedError(error)) {
      errorStream = merge(errorStream, processError(error))
    }
    return errorStream
  }))

const userImageUploadEpic: Epic = (action$) =>
  action$
    .pipe(filterRequestOfType(USER_IMAGE_UPLOAD, 'request')).pipe(
      mergeMap((action) => {
        const { file, id, type } = action.payload.params

        const formData = new FormData()
        const fileName = file.name || file.type.replace('/', '.')
        formData.append('file', file, fileName)
        formData.append('type', type)
        const localUrl = URL.createObjectURL(file)

        return merge(
          postMultipart(POST_MEDIA_IMAGE_URL, { body: formData }).pipe(
            map((response) => userImageUploadActionCreator.success(action.payload.params, {
              image: response.response,
            })))
            .pipe(handleErrors((error) => of(userImageUploadActionCreator.fail(action.payload.params, error.status)))),
          from(getImageSize(localUrl)).pipe(
            filter((size): size is ImageSize => !!size),
            map(({ width, height }) => {
              const blobUrl = URL.createObjectURL(file)
              return userImageLocalUpdateActionCreator({
                id,
                localImage: {
                  id,
                  sources: [{
                    width,
                    height,
                    url: blobUrl,
                  }],
                },
              })
            })),
        )
      }))

const userImageUploadSuccessEpic: Epic = (action$, store: Store) =>
  action$
    .pipe(filterRequestOfType(USER_IMAGE_UPLOAD, 'success')).pipe(
      mergeMap((action) => {
        const state = store.getState()
        const { id } = action.payload.params
        const imageState = getItemFromCollection<UserImage, 'id'>(state.app.userImages, id)
        if (imageState && imageState.localImage) {
          URL.revokeObjectURL(imageState.localImage.sources[0].url)
        }
        return empty()
      }))

const userImageEpics = combineEpics(
  userImageUploadEpic,
  userImageUploadSuccessEpic,
)

export default userImageEpics
